import SEOHead from '@/components/SEOHead';
import AboutHeroV2 from '@/components/marketing/about/v2/AboutHeroV2';
import ManifestoSectionV2 from '@/components/marketing/about/v2/ManifestoSectionV2';
import BeforeAfterAboutV2 from '@/components/marketing/about/v2/BeforeAfterAboutV2';
import ApproachPillarsV2 from '@/components/marketing/about/v2/ApproachPillarsV2';
import StatsGridV2 from '@/components/marketing/about/v2/StatsGridV2';
import TeamGridV2 from '@/components/marketing/about/v2/TeamGridV2';
import { FinalCtaSection } from '@/components/marketing/v2/FinalCtaSection';

const ABOUT_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: 'À propos de Velko POS',
  url: 'https://velko-pos.com/a-propos',
  mainEntity: {
    '@type': 'Organization',
    name: 'Velko',
    alternateName: 'Velko POS',
    url: 'https://velko-pos.com',
    logo: 'https://velko-pos.com/brand/velko-lockup.svg',
    description:
      'Velko POS est une caisse pensée, codée et testée en Afrique francophone : offline-first, Mobile Money natif, support humain en français.',
    foundingDate: '2025',
    foundingLocation: { '@type': 'Place', name: 'Yaoundé, Cameroun' },
    address: { '@type': 'PostalAddress', addressLocality: 'Yaoundé', addressCountry: 'CM' },
    areaServed: ['CM', 'CI', 'SN', 'BF', 'ML', 'GN', 'CD', 'CG'],
    sameAs: ['https://www.facebook.com/velkopos.sarl'],
  },
};

export default function About() {
  return (
    <>
      <SEOHead
        title="À propos — Construits à Yaoundé, pour toute l'Afrique | Velko POS"
        description="Velko POS est une caisse pensée, codée et testée en Afrique francophone. Offline-first, Mobile Money natif, support humain en français."
        path="/a-propos"
        jsonLd={ABOUT_JSON_LD}
        breadcrumbs={[
          { name: 'Accueil', path: '/' },
          { name: 'À propos', path: '/a-propos' },
        ]}
      />

      <AboutHeroV2 />
      <ManifestoSectionV2 />
      <BeforeAfterAboutV2 />
      <ApproachPillarsV2 />
      <StatsGridV2 />
      <TeamGridV2 />

      <FinalCtaSection
        eyebrow="Essaie Velko"
        title="Une caisse pensée pour l'Afrique."
        highlight="Prête aujourd'hui."
        subtitle="Offline-first, Mobile Money natif, support humain en français. Teste 14 jours sans carte bancaire, garde le contrôle total de tes données."
        primaryLabel="Commencer gratuitement"
        primaryTo="/register"
        secondaryLabel="Parler à l'équipe"
        secondaryTo="/contact"
        guarantees={["14 jours d'essai", 'Sans CB', 'Support francophone', 'Annulable 1 clic']}
      />
    </>
  );
}
